import { render, staticRenderFns } from "./Panchayaths.vue?vue&type=template&id=20c368e6&"
import script from "./Panchayaths.vue?vue&type=script&lang=js&"
export * from "./Panchayaths.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Panchayaths.vue"
export default component.exports